import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import VideocamIcon from '@mui/icons-material/Videocam';
import {
  Box,
  IconButton,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from '@mui/material';
import React from 'react';

export default function ImageCarouselSlideVideoControls({
  index,
  isVideo,
  videoURL,
  onToggleVideo,
  onVideoURLChange,
  onOpenLibrary,
}: {
  index: number;
  isVideo: boolean;
  videoURL?: string;
  onToggleVideo: (isVideo: boolean) => void;
  onVideoURLChange: (url: string) => void;
  onOpenLibrary: () => void;
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={isVideo ? 'video' : 'image'}
        onChange={(_event, value) => {
          if (value !== null) onToggleVideo(value === 'video');
        }}
        aria-label={`Slide ${index + 1} media type`}
        sx={{ alignSelf: 'flex-start' }}
      >
        <ToggleButton value="image" aria-label={`Use image for slide ${index + 1}`}>
          <ImageIcon fontSize="small" />
        </ToggleButton>
        <ToggleButton value="video" aria-label={`Use video for slide ${index + 1}`}>
          <VideocamIcon fontSize="small" />
        </ToggleButton>
      </ToggleButtonGroup>

      {isVideo && (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <TextField
            size="small"
            fullWidth
            label="YouTube or Vimeo URL"
            value={videoURL ?? ''}
            onChange={(event) => onVideoURLChange(event.target.value)}
            placeholder="https://www.youtube.com/watch?v=…"
          />
          <Tooltip title="Choose from media library">
            <IconButton
              size="small"
              onClick={onOpenLibrary}
              aria-label={`Choose video from library for slide ${index + 1}`}
              sx={{ mt: 0.75, flexShrink: 0 }}
            >
              <VideoLibraryIcon />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
}
